import styled, { css } from 'styled-components';
import { theme } from '../../theme/theme';

export const H2 = styled.h2`
  grid-row-end: span 1;
  grid-column-end: span 1;
  text-align: left;
  font-size: 1.75rem;
  font-weight: 500;

  margin: 1em 0 0.5em 0;

  &.frontEndTitle {
    grid-area: 9 / 1;
  }

  @media (min-width: ${theme.sizes.phone}px) {
    &.frontEndTitle {
      grid-area: none;
    }
    font-size: 2.25rem;
  }

  ${props =>
    props.visible === 'hidden' &&
    css`
      display: none;
    `};
`;
